<template>
  <app-form-field :id="id" :title="title" :show-label="showLabel">
    <div class="perc-inp">
      <input
        :id="id"
        v-model="numberValue"
        type="text"
        :name="name"
        :data-qa="id"
        maxlength="10"
        :disabled="isReadOnly || null"
        @change="updatePercentageField"
      />
      <span class="perc-postfix"> % </span>
    </div>
  </app-form-field>
</template>

<script>
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'

const percent = new Intl.NumberFormat('nl-NL', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 5,
})

export default {
  components: {
    AppFormField,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    percentage: {
      type: Number,
      default: 0,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue'],
  data() {
    return {
      numberValue: this.percentage ? this.percentage : Number(0),
    }
  },
  methods: {
    updatePercentageField() {
      this.$emit('change', this.toNumber(this.numberValue))
      this.$emit('update:modelValue', this.toNumber(this.numberValue))
    },
    toNumber(percentageInput) {
      const matches = new RegExp(/\.\d{1,2}$/).test(percentageInput)
      let number

      if (matches) {
        number = Number(percentageInput)
      } else {
        number = Number(
          percentageInput.replace(new RegExp(/\./, 'g'), '').replace(new RegExp(/\,/, 'g'), '.')
        )
      }

      if (Number.isNaN(number)) return 0

      return number
    },
  },
}
</script>

<style lang="scss" scoped>
.perc-inp {
  display: flex;
}

.perc-postfix {
  font-size: 1rem;
  background: #dae2e5;
  padding: 0.41667rem 0.3rem;
}
</style>
